export default "__VITE_ASSET__DS_kCE7M__"